import axios from 'axios';
import { CertificateFormatOutput, CUSTOM_PDF_DATA_URL_MIME_TYPE, } from './legacy-model.js';
export const validateCertificateAccessToken = async (root, key, certificate) => axios
    .post(`${root}/legacy/image-store/certificate/${certificate}/authorize`, {
    encryptionKey: key,
})
    .then((output) => output.data);
export const getValidatedCertificate = async (root, certificate, token) => doGetValidatedCertificate(root, certificate, token, CertificateFormatOutput.IMAGE);
export const getValidatedCertificateAsset = async (root, certificate, asset, token) => axios
    .get(`${root}/legacy/image-store/certificate/${certificate}/asset/${asset}`, {
    headers: {
        Authorization: token.value(),
    },
})
    .then((response) => response.data)
    .then(async (response) => axios.get(response.location, { responseType: 'arraybuffer' }));
export const supportsEdci = async (root, certificate) => axios
    .head(`${root}/legacy/image-store/${certificate}`, {
    headers: {
        accept: 'application/json+eml',
    },
})
    .then((output) => output.status === 201)
    .catch((e) => (e.response?.status === 404 ? Promise.resolve(false) : e));
export const getCertificatePdf = async (root, certificate, languageTag, accessToken) => axios
    .post(`${root}/legacy/image-store/certificate/${certificate}/pdf`, {
    accessToken: accessToken,
    languageTag: languageTag,
}, {
    headers: {
        accept: CUSTOM_PDF_DATA_URL_MIME_TYPE,
    },
})
    .then((output) => output.data);
export const getValidatedEdciCertificate = async (root, certificate, token) => doGetValidatedCertificate(root, certificate, token, CertificateFormatOutput.EML_JSON);
const doGetValidatedCertificate = async (root, certificate, token, output) => axios
    .post(`${root}/legacy/image-store/${certificate}`, {
    accessToken: token,
}, {
    headers: {
        accept: output,
    },
})
    .then((output) => output.data);
export const getCertificatePublicImageUrl = (root, certificateId) => `${root}/legacy/image-store/certificate/${certificateId}/encryptedImageUrl`;
//# sourceMappingURL=image-store.js.map